module.exports = "/images/Logo_Product_def_e-ppt-all-h-100-7c045b2ab15d4aafe832081dc4102e4c.png";